<template>
  <div>
    <page-layout>
      <error-global ref="ErrorGlobal"></error-global>

      <div class="container">
        <h1>My Account</h1>
        <div class="box" v-if="customer">
          <div class="line">
            <div class="row">
              <div class="col-8">Name</div>
              <div class="col-16">{{ customer.name }}</div>
            </div>
          </div>
          <div v-if="customer.company" class="line">
            <div class="row">
              <div class="col-8">Company</div>
              <div class="col-16">{{ customer.company }}</div>
            </div>
          </div>
          <div class="line">
            <div class="row">
              <div class="col-8">Phone</div>
              <div class="col-16">{{ customer.phone | formatPhone }}</div>
            </div>
          </div>
          <div class="line">
            <div class="row">
              <div class="col-8">Email</div>
              <div class="col-16">{{ customer.email }}</div>
            </div>
          </div>
          <div class="line">
            <div class="row">
              <div class="col-8">Address</div>
              <div class="col-16">{{ customer.city }}, {{ customer.state }}</div>
            </div>
          </div>
        </div>
      </div>

    </page-layout>
  </div>
</template>

<script>
import ErrorGlobal from '@/components/ErrorGlobal.vue';
import PageLayout from '@/components/PageLayout.vue';
import Http from '@/lib/http';

export default {
  name: 'account',
  components: {
    ErrorGlobal,
    PageLayout,
  },
  props: {},
  data() {
    return {
      customer: {},
    };
  },
  created() {
    this.getCustomer();
  },
  methods: {
    getCustomer() {
      Http.get('account/main/get').then((response) => {
        this.customer = response.data.customer;
      }).catch((error) => {
        if (error.response) {
          this.$refs.ErrorGlobal.show(error.response.data.error.message);
        }
      });
    },
  },
};
</script>

<style scoped>
.line {
  border-bottom: 1px solid #e1e1e1;
  margin-bottom: 20px;
  padding-bottom: 20px;
}
.line:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}
</style>
